
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[projectId]/settings/general",
      function () {
        return require("private-next-pages/[projectId]/settings/general.tsx");
      }
    ]);
  